import { useRef } from "react";

import { Box, Typography, makeStyles, Grid } from "@material-ui/core";
import DatePicker from "react-multi-date-picker";

import { DATE_PART_PERIODS } from "../../../../dashboard/constants";
import { ColorIndicator } from "../../../../../components/colorIndicator";
import { SmallRectangleButton } from "../../../../../components/base/Button";
import { Toggle } from "../../../../../components/toggle";
import CalendarIcon from "../../../../../assets/images/icons/calendar.svg";
import { Icon } from "../../../../../components/base/Icon";

const weekDays = ["S", "M", "T", "W", "T", "F", "S"];
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
    display: "flex",
    alignItems: "center",
  },
  legend: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(10),
  },
}));

export const Top = ({
  period,
  onPeriodChange,
  bars,
  toggleFilter,
  setToggleFilter,
  toggleOptions,
  title,
  startDate,
  endDate,
}) => {
  const classes = useStyles();
  const ref = useRef();

  return (
    <Box className={classes.box}>
      <Grid container spacing={2}>
        <Grid item>
          <Typography variant="h4">{title}</Typography>
        </Grid>
        <Grid item>
          <Toggle value={toggleFilter} options={toggleOptions} onChanged={setToggleFilter} />
        </Grid>
        <Grid item>
          <Box className={classes.legend}>
            {bars.map((bar, i) => (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: `${i ? 0 : 20}px`,
                }}
              >
                <ColorIndicator color={bar.fill} />
                <Typography>{bar.dataKey}</Typography>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>
      <Grid container alignItems="center" justifyContent="flex-end" spacing={2}>
        {DATE_PART_PERIODS.map((p, i) =>
          p.show ? (
            <Grid key={i} item>
              <SmallRectangleButton
                text={p.name}
                active={p.name === period.name}
                onClick={() => onPeriodChange(p)}
              />
            </Grid>
          ) : null
        )}
        <Grid item>
          <DatePicker
            value={[startDate, endDate]}
            className="purple"
            weekDays={weekDays}
            maxDate={new Date()}
            months={months}
            range
            ref={ref}
            render={(value, openCalendar) => {
              return <Icon hoverable src={CalendarIcon} onClick={openCalendar} />;
            }}
            calendarPosition="bottom-right"
            fixMainPosition
            numberOfMonths={2}
            onChange={([start, end]) => {
              if (start && end) {
                onPeriodChange({ name: "RANGE" }, new Date(start), new Date(end));
                ref.current.closeCalendar();
              }
            }}
            weekStartDayIndex={1}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
